import { About } from './About';
import { Advertise } from './Advertise';
import { CCPA } from './CCPA';
import { Privacy } from './Privacy';
import { Terms } from './Terms';
import { Accessibility } from './Accessibility';
import { GDPR } from './GDPR';

export default {
  about: About,
  advertise: Advertise,
  ccpa: CCPA,
  privacy: Privacy,
  terms: Terms,
  accessibility: Accessibility,
  gdpr: GDPR
};


/** WEBPACK FOOTER **
 ** ./views/document/DocTypes.js
 **/